module.exports = __webpack_public_path__ + "assets/img/761587008118_.pic_hd.46c37f47.jpg";